export const SET_SETTINGS = "SETTINGS_SET_SETTINGS";
export const SET_ERROR = "SETTINGS_SET_ERROR";
export const CHANGE_ATTR = "SETTINGS_CHANGE_ATTR"